import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=c0d3d6a2&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=c0d3d6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d3d6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0d3d6a2')) {
      api.createRecord('c0d3d6a2', component.options)
    } else {
      api.reload('c0d3d6a2', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=c0d3d6a2&scoped=true&", function () {
      api.rerender('c0d3d6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/teamMember.vue"
export default component.exports